import React from 'react';
import PropTypes from 'prop-types';

import {Box} from "@mui/material";

StatusPill.propTypes = {
    bg: PropTypes.string,
    border: PropTypes.string,
    dotColor: PropTypes.string,
    textColor: PropTypes.string,
    children: PropTypes.node
};

function StatusPill({ bg, border, dotColor, textColor, children }) {
    return (
        <Box sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            backgroundColor: bg,
            border: `1px solid ${border}`,
            borderRadius: "999px",
            px: "8px",
            height: "24px",
            whiteSpace: "nowrap",
        }}>
            <Box
                sx={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    backgroundColor: dotColor,
                    flexShrink: 0
                }}
            />
            <span style={{
                fontSize: "14px",
                fontWeight: 400,
                color: textColor,
                lineHeight: 1
            }}>
                {children}
            </span>
        </Box>
    );
}

export default StatusPill;
